export const getPromocode = /* GraphQL */ `
  query getPromocode($input: GetPromocodeRequesterInput!, $nextToken: String) {
    getPromocode(input: $input, nextToken: $nextToken) {
      items {
        recordId
        type
        data
      }
      nextToken
    }
  }
`;
